import $ from 'jquery';
/* global x5script */

class Blog {
  constructor() {
    this.blog = $('.js-blog');
    this.header = $('.js-header');

    this.categorySearch = $('.js-search-box-category');
    this.postMeta = $('.js-post-meta');
    this.sideNav = $('.js-sidenav');
    this.sideNavData = {};

    this.searchCategory();
    this.sideNavInit();
    this.postReadingProgress();
    // this.postMetaButtons();
  }

  searchCategory() {
    this.categorySearch.on('change', e => {
      const { value } = e.target;
      let url = x5script.blogUrl;

      if (value.trim() !== '') {
        url = `${x5script.categoriesUrl}/${value}`;
      }

      window.location.replace(url);
    });
  }

  sideNavInit() {
    if (!this.sideNav.length) {
      return;
    }

    this.sideNavInner = this.sideNav.find('.js-sidenav-inner');
    this.sideNavList = this.sideNavInner.find('.js-sidenav-list');
    this.sideNavLoader = this.sideNavInner.find('.js-loader');
    this.sideNavHeading = this.sideNav.find('.js-sidenav-heading');
    this.sideNavHeadingInitialText = this.sideNavHeading.text();

    $(window).on('load scroll', () => {
      this.sideNavSticky();
    });

    this.sideNav.on('click', '.js-sidenav-button', e => {
      const button = $(e.currentTarget);
      this.sideNavSection = button.parent();
      this.sideNavRow = button.data('row');

      this.sideNavLoader.addClass('show');

      if (typeof this.sideNavData[this.sideNavRow] !== 'undefined') {
        this.sideNavList.stop().animate(
          {
            opacity: 0,
          },
          200,
          () => {
            this.sideNavShowSection();
          },
        );
      } else {
        this.sideNavList.stop().animate(
          {
            opacity: 0,
          },
          200,
        );

        $.post(
          x5script.ajaxurl,
          {
            action: 'x5_blog_sidenav',
            row_id: this.sideNavRow,
          },
          response => {
            if (response.ok) {
              this.sideNavData[this.sideNavRow] = response.data;
              this.sideNavShowSection();
            }
          },
        ).fail((xhr, status, error) => {
          // eslint-disable-next-line no-console
          console.log(error);
        });
      }
    });

    this.sideNavHeading.on('click', e => {
      const heading = $(e.currentTarget);

      if (this.sideNavInner.hasClass('has-active-section')) {
        this.sideNavLoader.addClass('show');

        this.sideNavList.stop().animate(
          {
            opacity: 0,
          },
          200,
          () => {
            this.sideNavSection
              .find('.js-section-description, .js-section-cat')
              .remove();
            this.sideNavSection.removeClass('is-active');
            this.sideNavInner.removeClass('has-active-section');
            heading.html(`<strong>${this.sideNavHeadingInitialText}</strong>`);

            this.sideNavLoader.removeClass('show');
            this.sideNavList.stop().animate(
              {
                opacity: 1,
              },
              200,
            );
          },
        );
      }
    });
  }

  sideNavShowSection() {
    this.sideNavSection.addClass('is-active');
    this.sideNavInner.addClass('has-active-section');
    this.sideNavLoader.removeClass('show');

    const data = this.sideNavData[this.sideNavRow];

    this.sideNavHeading.html(data.label);

    if (data.description !== '') {
      this.sideNavSection.append(
        `<p class="c-sidenav__section-description js-section-description">${
          data.description
        }</p>`,
      );
    }

    if (data.cats) {
      $.each(data.cats, (catId, catData) => {
        const ul = $(
          `<nav id="category-${catId}" class="c-sidenav__section-cat js-section-cat"><button>${
            catData.label
          }${data.icon}</button><ul class="o-list-bare"></ul></nav>`,
        );

        for (let i = 0; i < catData.posts.length; i += 1) {
          const post = catData.posts[i];

          ul.find('ul').append(
            `<li><a id="post-${post.ID}" href="${post.link}">${
              post.title
            }</a></li>`,
          );
        }

        this.sideNavSection.append(ul);
      });
    }

    this.sideNavList.stop().animate(
      {
        opacity: 1,
      },
      200,
    );

    this.sideNavSection.off('click', '.js-section-cat button');
    this.sideNavSection.on('click', '.js-section-cat button', e => {
      const button = $(e.currentTarget);
      button.toggleClass('is-active');
      button
        .parent()
        .find('ul')
        .slideToggle(300);
    });
  }

  sideNavSticky() {
    this.scrollTopPos = $(window).scrollTop();

    if ($(window).width() < 1025) {
      this.sideNavInner.css({
        top: 0,
      });
      return;
    }

    const columnHeight = this.sideNav.outerHeight();
    const navHeight = this.sideNavInner.outerHeight();
    const windowHeight = $(window).height();
    const notibar = $('.njt-nofi-container');
    const notiHeight = notibar.length ? notibar.outerHeight() : 0;

    if (columnHeight > navHeight) {
      const headerHeight = this.header.outerHeight() + notiHeight;
      const maxTopOffset = columnHeight - navHeight;
      const startPosition = this.sideNav.offset().top - headerHeight;
      const positionTop = this.scrollTopPos - startPosition;

      if (this.scrollTopPos > startPosition) {
        let topPos = positionTop + 15;

        if (positionTop >= maxTopOffset) {
          topPos = maxTopOffset;
        }

        if (topPos < 0) {
          topPos = 0;
        }

        if (navHeight + headerHeight > windowHeight) {
          topPos -= navHeight + headerHeight + 30 - windowHeight;
        }

        this.sideNavInner.css({
          top: topPos,
        });
      } else {
        this.sideNavInner.css({
          top: 0,
        });
      }
    }
  }

  postReadingProgress() {
    if (x5script.isArticle) {
      this.postReadingProgressCreateBar();
      this.postReadingProgressShow();

      $(window).on('scroll', () => {
        this.postReadingProgressShow();
      });
    }
  }

  postReadingProgressCreateBar() {
    this.postReadingProgressBar = $('<div></div>', {
      class: 'c-post-progress-bar',
      html:
        '<div class="c-post-progress-bar__inner js-post-progress-bar-inner"></div>',
    });

    this.header.append(this.postReadingProgressBar);
  }

  postReadingProgressShow() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollBottom =
      (document.scrollHeight || document.body.scrollHeight) -
      window.innerHeight;
    const scrollPercent = (scrollTop / scrollBottom) * 100;

    this.postReadingProgressBar.find('.js-post-progress-bar-inner').css({
      width: `${scrollPercent}%`,
    });
  }

  // postMetaButtons() {
  //   if (!this.postMeta.length) {
  //     return;
  //   }

  //   const buttons = this.postMeta.find('.js-post-meta-button');
  //   const sidebar = $('.js-sidebar');
  //   const closeBtn = sidebar.find('.js-sidebar-close');
  //   const sidebarSections = sidebar.find('.js-sidebar-section');

  //   buttons.on('click', e => {
  //     const button = $(e.currentTarget);
  //     const show = button.data('show');
  //     const target = sidebar.find(
  //       `.js-sidebar-section[data-show-if="${show}"]`,
  //     );

  //     if (target.length) {
  //       target.addClass('show');
  //       sidebar.addClass('is-active');
  //     }
  //   });

  //   closeBtn.on('click', () => {
  //     sidebar.removeClass('is-active');
  //     sidebarSections.removeClass('show');
  //   });
  // }
}

export default new Blog();



// WEBPACK FOOTER //
// ./src/scripts/modules/blog.js